export const DashboardType = {
  //columns x rows
  ...Object.fromEntries(
    Array.from({ length: 6 }, (_, columnIndex) =>
      Array.from({ length: 5 }, (_, rowIndex) => {
        const column = columnIndex + 1;
        const row = rowIndex + 1;
        return [`_${column}x${row}`, `${column}X${row}`];
      })
    ).flat()
  ),
};

export const DashboardTypeList = Array.from({ length: 5 }, (_, rowIndex) =>
  Array.from({ length: 6 }, (_, columnIndex) => {
    const column = columnIndex + 1;
    const row = rowIndex + 1;
    const value = DashboardType[`_${column}x${row}`];

    return { label: `${column}x${row}`, value, column, row };
  })
).flat();

export const DashboardPdfExportModeEnum = {
  FULL: 'FULL',
  PAGE_BY_PAGE: 'PAGE_BY_PAGE',
};

export const DashboardPdfExportModeList = [
  { label: 'Teljes riport', value: DashboardPdfExportModeEnum.FULL },
  { label: 'Oldalankénti riport', value: DashboardPdfExportModeEnum.PAGE_BY_PAGE },
];
